import apiRoutes from '../../../api-routes';
import { patchRequest } from 'js/helpers/apiClient';
import { useMutationWithLogout } from 'js/hooks/useMutationWithLogout';

export const useSetUserPassword = (options) => {
  return useMutationWithLogout(async ({ id, data }) => {
    const { data: password } = await patchRequest({
      url: apiRoutes.SET_PASSWORD.replace('{id}', id),
      data,
      headers: {
        Authorization: sessionStorage.getItem('token'),
      },
    });
    return password;
  }, options);
};
